// extracted by mini-css-extract-plugin
export default {"container":"_2H9zRqa49r","message":"I5qqgDqtgX","error":"Bh9dHjcFuV","icon":"_3c2SUpD1Wy","value":"_2gxPfXdIN1"};
    if(module.hot) {
      // 1625219528949
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  